"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCategoryItems = getCategoryItems;
exports.getCategoryNameFromItems = getCategoryNameFromItems;

function getItemsFromIDs(items, itemsArray) {
  return items.filter(function (item) {
    return itemsArray.includes(item.id) && item.is_special;
  });
}

function getCategoryItems(specials) {
  var filteredCategories = specials.categories;
  var groupedByCategory = [];
  filteredCategories.map(function (data) {
    var filteredItems = getItemsFromIDs(specials.items, data.items);

    if (filteredItems && filteredItems.length) {
      groupedByCategory.push({
        name: data.name,
        description: data.description,
        id: data.id,
        items: filteredItems
      });
    }
  });
  return groupedByCategory;
}

function getCategoryNameFromItems(itemId, category) {
  var categories = category.filter(function (item) {
    return item.items.includes(itemId);
  });

  if (categories && categories.length) {
    return categories[0].name;
  }

  return;
}